import md5 from 'md5';
import Cookies from 'js-cookie';
import {getStorage, setStorage} from './storage';

const BDUIDS = ['BAIDUID', 'BAIDUID_BFESS', 'BIDUPSID'];
const key = 'deviceId';

const randomString = length => {
    let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
};

export default () => {
    let deviceId = getStorage(key);
    if (!deviceId) {
        const id = BDUIDS.find(k => Cookies.get(k));
        deviceId = id ? Cookies.get(id) : randomString(32);
        deviceId = md5(deviceId);
        setStorage(deviceId);
    }

    return `pc-${deviceId}`;
};
